export const kpiData = {
  dailyApplications: 87,
  dailyApplicationsChange: 12.4,
  approvalRate: 35,
  approvalRateChange: -2.1,
  avgExpertScore: 4.3,
  avgExpertScoreChange: 0.8,
  activeAppointments: 214,
  activeAppointmentsChange: 18.5,
  dailyRevenue: 48750,
  dailyRevenueChange: 22.3,
  leadToAppointment: 22,
  leadToAppointmentChange: 3.2,
  avgCustomerRating: 4.6,
  avgCustomerRatingChange: 0.4,
};

export const dailyApplicationsTrend = [
  { gun: 'Pzt', basvuru: 65, onaylanan: 22, reddedilen: 28 },
  { gun: 'Sal', basvuru: 92, onaylanan: 32, reddedilen: 38 },
  { gun: 'Çar', basvuru: 78, onaylanan: 27, reddedilen: 33 },
  { gun: 'Per', basvuru: 110, onaylanan: 38, reddedilen: 45 },
  { gun: 'Cum', basvuru: 135, onaylanan: 47, reddedilen: 56 },
  { gun: 'Cmt', basvuru: 88, onaylanan: 31, reddedilen: 37 },
  { gun: 'Paz', basvuru: 54, onaylanan: 19, reddedilen: 22 },
];

export const approvalRateData = [
  { ay: 'Oca', oran: 31 },
  { ay: 'Şub', oran: 34 },
  { ay: 'Mar', oran: 33 },
  { ay: 'Nis', oran: 36 },
  { ay: 'May', oran: 35 },
  { ay: 'Haz', oran: 38 },
];

export const serviceCategoryData = [
  { name: 'Saç Kesimi', value: 35, color: '#ff4d4d' },
  { name: 'Sakal / Tıraş', value: 22, color: '#ff8c42' },
  { name: 'Boya & Röfle', value: 18, color: '#ffa94d' },
  { name: 'Bakım & Maske', value: 14, color: '#ffcc66' },
  { name: 'Diğer', value: 11, color: '#ff6b6b' },
];

export const funnelData = [
  { aşama: 'Reklam', sayi: 4800, renk: '#ff4d4d' },
  { aşama: 'Başvuru', sayi: 2240, renk: '#ff6b47' },
  { aşama: 'Eşleşme', sayi: 1120, renk: '#ff8c42' },
  { aşama: 'Randevu', sayi: 640, renk: '#ffa94d' },
  { aşama: 'Tamamlanan', sayi: 380, renk: '#ffcc66' },
];

export const hourlyHeatmapData = Array.from({ length: 7 }, (_, dayIdx) =>
  Array.from({ length: 24 }, (_, hourIdx) => {
    const base = Math.random() * 100;
    const peakHour = hourIdx >= 10 && hourIdx <= 14 ? 1.8 : hourIdx >= 18 && hourIdx <= 21 ? 1.5 : 1;
    const weekendFactor = dayIdx >= 5 ? 0.7 : 1;
    return Math.round(base * peakHour * weekendFactor);
  })
);

export const expertApplications = [
  { id: 1, isim: 'Ahmet Yılmaz', sehir: 'İstanbul', uzmanlik: 'Saç Kesimi', deneyim: 8, skor: 4.7, tarih: '2026-04-12', durum: 'Beklemede', telefon: '0532 123 45 67', email: 'ahmet@email.com' },
  { id: 2, isim: 'Mehmet Demir', sehir: 'Ankara', uzmanlik: 'Sakal & Tıraş', deneyim: 5, skor: 4.2, tarih: '2026-04-12', durum: 'Onaylandı', telefon: '0543 234 56 78', email: 'mehmet@email.com' },
  { id: 3, isim: 'Kemal Çelik', sehir: 'İzmir', uzmanlik: 'Boya & Röfle', deneyim: 12, skor: 4.9, tarih: '2026-04-11', durum: 'İncelemede', telefon: '0554 345 67 89', email: 'kemal@email.com' },
  { id: 4, isim: 'Emre Kaya', sehir: 'Bursa', uzmanlik: 'Saç Kesimi', deneyim: 3, skor: 3.8, tarih: '2026-04-11', durum: 'Reddedildi', telefon: '0505 456 78 90', email: 'emre@email.com' },
  { id: 5, isim: 'Hasan Öztürk', sehir: 'Antalya', uzmanlik: 'Bakım & Maske', deneyim: 7, skor: 4.5, tarih: '2026-04-10', durum: 'Onaylandı', telefon: '0516 567 89 01', email: 'hasan@email.com' },
  { id: 6, isim: 'Ali Arslan', sehir: 'İstanbul', uzmanlik: 'Saç Kesimi', deneyim: 15, skor: 4.8, tarih: '2026-04-10', durum: 'Beklemede', telefon: '0527 678 90 12', email: 'ali@email.com' },
  { id: 7, isim: 'Mustafa Şahin', sehir: 'Konya', uzmanlik: 'Sakal & Tıraş', deneyim: 6, skor: 4.1, tarih: '2026-04-09', durum: 'İncelemede', telefon: '0538 789 01 23', email: 'mustafa@email.com' },
  { id: 8, isim: 'İbrahim Yıldız', sehir: 'Adana', uzmanlik: 'Boya & Röfle', deneyim: 9, skor: 4.6, tarih: '2026-04-09', durum: 'Onaylandı', telefon: '0549 890 12 34', email: 'ibrahim@email.com' },
  { id: 9, isim: 'Osman Güler', sehir: 'Kayseri', uzmanlik: 'Saç Kesimi', deneyim: 4, skor: 3.9, tarih: '2026-04-08', durum: 'Reddedildi', telefon: '0550 901 23 45', email: 'osman@email.com' },
  { id: 10, isim: 'Sercan Aydın', sehir: 'İstanbul', uzmanlik: 'Bakım & Maske', deneyim: 11, skor: 4.7, tarih: '2026-04-08', durum: 'Beklemede', telefon: '0561 012 34 56', email: 'sercan@email.com' },
  { id: 11, isim: 'Cem Koç', sehir: 'Ankara', uzmanlik: 'Saç Kesimi', deneyim: 2, skor: 3.5, tarih: '2026-04-07', durum: 'Reddedildi', telefon: '0572 123 45 67', email: 'cem@email.com' },
  { id: 12, isim: 'Burak Erdoğan', sehir: 'İzmir', uzmanlik: 'Sakal & Tıraş', deneyim: 7, skor: 4.3, tarih: '2026-04-07', durum: 'Onaylandı', telefon: '0583 234 56 78', email: 'burak@email.com' },
];

export const scoringCriteria = [
  { kriter: 'Deneyim Yılı', agirlik: 20, ortalama: 6.8 },
  { kriter: 'Sertifika Sayısı', agirlik: 15, ortalama: 3.2 },
  { kriter: 'Referans Kalitesi', agirlik: 18, ortalama: 4.1 },
  { kriter: 'Profil Tamamlama', agirlik: 12, ortalama: 78 },
  { kriter: 'Hizmet Çeşitliliği', agirlik: 10, ortalama: 4.3 },
  { kriter: 'Sosyal Medya', agirlik: 8, ortalama: 2.9 },
  { kriter: 'Müşteri Puanı', agirlik: 10, ortalama: 4.5 },
  { kriter: 'Tamamlanan İş', agirlik: 7, ortalama: 23 },
];

export const scoreDistribution = [
  { aralik: '1-2', sayi: 12 },
  { aralik: '2-3', sayi: 28 },
  { aralik: '3-3.5', sayi: 45 },
  { aralik: '3.5-4', sayi: 87 },
  { aralik: '4-4.5', sayi: 134 },
  { aralik: '4.5-5', sayi: 76 },
];

export const topScoredExperts = [
  { isim: 'Kemal Çelik', skor: 4.9, sehir: 'İzmir', is: 145 },
  { isim: 'Ali Arslan', skor: 4.8, sehir: 'İstanbul', is: 132 },
  { isim: 'Ahmet Yılmaz', skor: 4.7, sehir: 'İstanbul', is: 118 },
  { isim: 'Sercan Aydın', skor: 4.7, sehir: 'İstanbul', is: 109 },
  { isim: 'Hasan Öztürk', skor: 4.5, sehir: 'Antalya', is: 97 },
];

export const customerLeads = [
  { id: 1, hizmet: 'Saç Kesimi', lokasyon: 'Kadıköy, İstanbul', talep: '2026-04-14 09:30', kaynak: 'Reklam', durum: 'Eşleşme Bekleniyor' },
  { id: 2, hizmet: 'Sakal Tıraşı', lokasyon: 'Çankaya, Ankara', talep: '2026-04-14 10:15', kaynak: 'Organik', durum: 'Randevu Oluşturuldu' },
  { id: 3, hizmet: 'Boya & Röfle', lokasyon: 'Konak, İzmir', talep: '2026-04-14 11:00', kaynak: 'Reklam', durum: 'Tamamlandı' },
  { id: 4, hizmet: 'Bakım & Maske', lokasyon: 'Nilüfer, Bursa', talep: '2026-04-14 11:45', kaynak: 'Sosyal Medya', durum: 'Eşleşme Bekleniyor' },
  { id: 5, hizmet: 'Saç Kesimi', lokasyon: 'Muratpaşa, Antalya', talep: '2026-04-14 12:20', kaynak: 'Organik', durum: 'İptal Edildi' },
  { id: 6, hizmet: 'Sakal Tıraşı', lokasyon: 'Beşiktaş, İstanbul', talep: '2026-04-14 13:10', kaynak: 'Reklam', durum: 'Randevu Oluşturuldu' },
  { id: 7, hizmet: 'Saç Kesimi', lokasyon: 'Altındağ, Ankara', talep: '2026-04-14 14:00', kaynak: 'Organik', durum: 'Eşleşme Bekleniyor' },
  { id: 8, hizmet: 'Boya & Röfle', lokasyon: 'Bornova, İzmir', talep: '2026-04-14 14:30', kaynak: 'Reklam', durum: 'Tamamlandı' },
];

export const locationLeadData = [
  { sehir: 'İstanbul', talep: 1840 },
  { sehir: 'Ankara', talep: 920 },
  { sehir: 'İzmir', talep: 680 },
  { sehir: 'Bursa', talep: 420 },
  { sehir: 'Antalya', talep: 380 },
  { sehir: 'Adana', talep: 290 },
  { sehir: 'Konya', talep: 240 },
  { sehir: 'Kayseri', talep: 190 },
];

export const revenueData = [
  { gun: '01 Nis', gunluk: 42000, komisyon: 12600 },
  { gun: '02 Nis', gunluk: 38500, komisyon: 11550 },
  { gun: '03 Nis', gunluk: 51200, komisyon: 15360 },
  { gun: '04 Nis', gunluk: 47800, komisyon: 14340 },
  { gun: '05 Nis', gunluk: 62400, komisyon: 18720 },
  { gun: '06 Nis', gunluk: 58900, komisyon: 17670 },
  { gun: '07 Nis', gunluk: 71200, komisyon: 21360 },
  { gun: '08 Nis', gunluk: 65400, komisyon: 19620 },
  { gun: '09 Nis', gunluk: 78900, komisyon: 23670 },
  { gun: '10 Nis', gunluk: 72100, komisyon: 21630 },
  { gun: '11 Nis', gunluk: 84500, komisyon: 25350 },
  { gun: '12 Nis', gunluk: 79300, komisyon: 23790 },
  { gun: '13 Nis', gunluk: 91200, komisyon: 27360 },
  { gun: '14 Nis', gunluk: 48750, komisyon: 14625 },
];

export const topEarningExperts = [
  { isim: 'Kemal Çelik', sehir: 'İzmir', kazanc: 18450, is: 24 },
  { isim: 'Ali Arslan', sehir: 'İstanbul', kazanc: 16800, is: 22 },
  { isim: 'Ahmet Yılmaz', sehir: 'İstanbul', kazanc: 15200, is: 20 },
  { isim: 'Sercan Aydın', sehir: 'İstanbul', kazanc: 13900, is: 18 },
  { isim: 'Hasan Öztürk', sehir: 'Antalya', kazanc: 12400, is: 16 },
];

export const serviceRevenueData = [
  { hizmet: 'Saç Kesimi', gelir: 184000 },
  { hizmet: 'Sakal / Tıraş', gelir: 112000 },
  { hizmet: 'Boya & Röfle', gelir: 148000 },
  { hizmet: 'Bakım & Maske', gelir: 86000 },
  { hizmet: 'Diğer', gelir: 54000 },
];

export const performanceScatterData = [
  { puan: 4.9, kazanc: 18450, is: 145 },
  { puan: 4.8, kazanc: 16800, is: 132 },
  { puan: 4.7, kazanc: 15200, is: 118 },
  { puan: 4.7, kazanc: 13900, is: 109 },
  { puan: 4.5, kazanc: 12400, is: 97 },
  { puan: 4.3, kazanc: 10200, is: 84 },
  { puan: 4.2, kazanc: 9800, is: 78 },
  { puan: 4.1, kazanc: 8900, is: 72 },
  { puan: 3.9, kazanc: 7200, is: 58 },
  { puan: 3.8, kazanc: 6500, is: 48 },
  { puan: 3.5, kazanc: 4800, is: 34 },
  { puan: 3.2, kazanc: 3200, is: 22 },
];

export const algorithmExplanation = [
  {
    icon: 'ri-award-line',
    baslik: 'Yüksek Puan = Daha Fazla Görünürlük',
    aciklama: 'Skoru 4.0 üzeri uzmanlar, arama sonuçlarında ve eşleşme algoritmalarında öncelikli olarak listelenir.',
    renk: '#ff4d4d',
  },
  {
    icon: 'ri-eye-line',
    baslik: 'Daha Fazla Görünürlük = Daha Fazla İş',
    aciklama: 'Algoritma üst sıralardaki uzmanlara %3x daha fazla müşteri talebi yönlendirir.',
    renk: '#ff6b47',
  },
  {
    icon: 'ri-briefcase-4-line',
    baslik: 'Daha Fazla İş = Daha Fazla Gelir',
    aciklama: 'Her tamamlanan iş hem uzmanın gelirini hem de skorunu artırarak pozitif döngü oluşturur.',
    renk: '#ff8c42',
  },
  {
    icon: 'ri-line-chart-line',
    baslik: 'Sürekli Büyüme Döngüsü',
    aciklama: 'Müşteri puanlamaları anlık işlenerek uzman skoru güncellenir ve sistem kendi kendini optimize eder.',
    renk: '#ffa94d',
  },
];
